var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 62,
  rx: 10,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M90 52H70.1064C65.0851 52 60.3969 49.4876 57.6163 45.3065L38.5871 16.6935C35.8065 12.5124 31.1183 10 26.097 10H10",
  stroke: "url(#paint0_linear_1164_2150)",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1164_2150",
  x1: 87.5,
  y1: -8.9,
  x2: 3.91432,
  y2: 12.5877,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D85FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8525FF"
})));

function SvgBearCallSpread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 62,
    viewBox: "0 0 100 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearCallSpread);
export default __webpack_public_path__ + "static/media/BearCallSpread.46788a49ba0a9693c1b58e6cda5dcf76.svg";
export { ForwardRef as ReactComponent };